import { Box } from '@iheartjane/reefer';

import { Modal } from '@jane/monolith/components/modal';

import { LogoutForm } from './form';

interface Props {
  onLogout(): void;
}

export const LogoutModal = ({ onLogout }: Props) => {
  return (
    <Modal contentLabel="Sign out" fixedBody width="small">
      {(closeModal) => (
        <Box p={20}>
          <LogoutForm
            embeddedMode={false}
            onCancel={closeModal}
            onLogout={onLogout}
          />
        </Box>
      )}
    </Modal>
  );
};
